var path = '/user/change-password/change-password.html';
var html = "<md-card> <md-card-header> <md-card-header-text> <h1 class=\"md-title text-center\">{{::route.title}}</h1> </md-card-header-text> </md-card-header> <md-card-content> <article ng-include=\"'/user/change-password/_form.html'\" class=md-block></article> </md-card-content> </md-card> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./user/change-password/change-password.html
// module id = 117
// module chunks = 0